import React from "react";

import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
} from 'chart.js';

import { Radar } from 'react-chartjs-2'; 

ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);

const options = {
    responsive: true, 
    maintainAspectRatio: true,
    plugins: {
        legend: {
            display: false, 
        },
        layout: {
            autoPadding: true
        }, 
        title: {
            font: {
                size: 15
            },
        }
    },
    elements: {
        point: {
            hitRadius: '2'
        }
    },
    scale: { 
        display: false,
        min: 0,
        max: 5
    },
    ticks: {
        beginAtZero: true,
        stepSize: 1,
        count: 5,
        font: {
			size: 15
		},
    },
    scales: { 
        r: {
			pointLabels: {
			  font: {
				size: 15
			  }
			}
		}
    } 
} 

const GraficoTeia = ({ data }) => {

    const chartData = {
        labels: data.map(item => item.name),
        datasets: [
            {
                label: 'Grau de Inovação',
                data: data.map(item => item.value), 
                backgroundColor: 'rgba(73,85,178, 0.2)',
                borderColor: '#002d82',
                borderWidth: 2 
            },
        ],
    };

    return (
        <div className="container-fluid col-md-12 col-lg-7" style={{margin: 'auto'}}>
            <Radar data={chartData} options={options} />
        </div>
    );
};

export default GraficoTeia;